var render = function render(){var _vm=this,_c=_vm._self._c;return _c('np-base',_vm._g({attrs:{"value":_vm.value,"field":_vm.field,"records":_vm.records,"default-value":_vm.defaultValue},on:{"input":v => (_vm.value = v)}},_vm.listeners),[_c('Input',{staticClass:"field-input operation",attrs:{"type":"text"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }